import Bugsnag from './Bugsnag';
import React from 'react';

export const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
